import React from 'react';

import Footer from '../../../Shared/Footer';
import Header from '../../../Shared/Header';
import { PrintProvider } from '../Participant/Content/Ticket/context';

import * as S from './styles';
import Content from './Content';

const TicketForm = () => {
  return (
    <PrintProvider>
      <S.Wrapper>
        <S.HeaderContainer>
          <Header />
        </S.HeaderContainer>

        <S.ContentContainer>
          <Content />
        </S.ContentContainer>

        <S.FooterContainer>
          <Footer />
        </S.FooterContainer>
      </S.Wrapper>
    </PrintProvider>
  );
};

export default TicketForm;
